import {
  MessageFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Divider } from "antd";

const reportsTab = [
  {
    label: "Inventory",
    key: "1",
    mode: 'items'
  },
  {
    label: "Party Details",
    key: "2",
    mode: 'party'
  },
  {
    label: "Summary",
    key: "3",
    mode: 'summary'
  },
  {
    label: "All",
    key: "2",
    mode: 'all'
  },
  //   {
  //     label: "Party Wise Report",
  //     key: "3",
  //   },
];

const ledgerStatementList = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[130px] h-[60px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex border-x-0 border-t-0 text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <MessageFilled className="mr-1" />
          SMS
        </a>
      </p>
      <Divider className="w-[185%] mt-[4px] ml-[-24px]" />
      <p className="flex mt-[-20px] text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <WhatsAppOutlined className="mr-1" />
          Whatsapp
        </a>
      </p>
    </div>
  </div>
);

export { reportsTab, ledgerStatementList };
